import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose"; // @flow

import React from 'react';
import { useDebounce } from '../hooks/use-debounce';
import DefaultTheme from './theme';
export var InputTheme = DefaultTheme;
/*::
import type { ElementType, Node } from 'react';
import type { StyledComponent } from 'styled-components';

export type InputThemeType = {|
  Main: * => Node,
  Input: * => Node,
  Icon: * => Node,
|};

type Props = {|
  type?: 'number' | 'text' | 'password' | 'tel' | 'url' | 'email',
  className?: string;
  value?: string,
  onChange?: (value: string) => any,
  debounceTimeout?: number,
  icon?: ElementType;
  disabled?: boolean;
  error?: boolean;
  readOnly?: boolean;
  onClick?: (e: any) => void;
  onKeyDown?: (e: any) => void;
  onMouseDown?: (e: any) => void;
  onFocus?: (e: FocusEvent) => void;
  onBlur?: (e: FocusEvent) => void;
  theme?: InputThemeType,
  autocomplete?: string;
  'data-test'?: string;
  placeholder?: string;
  rest?: any,
|};
*/

var Input = function Input(_ref
/*: Props */
, ref) {
  var type = _ref.type,
      icon = _ref.icon,
      className = _ref.className,
      placeholder = _ref.placeholder,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$debounceTimeout = _ref.debounceTimeout,
      debounceTimeout = _ref$debounceTimeout === void 0 ? 300 : _ref$debounceTimeout,
      _ref$error = _ref.error,
      error = _ref$error === void 0 ? false : _ref$error,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? '' : _ref$value,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? function () {
    return undefined;
  } : _ref$onChange,
      _ref$readOnly = _ref.readOnly,
      readOnly = _ref$readOnly === void 0 ? false : _ref$readOnly,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? DefaultTheme : _ref$theme,
      _ref$onFocus = _ref.onFocus,
      onFocus = _ref$onFocus === void 0 ? function () {
    return undefined;
  } : _ref$onFocus,
      _ref$onBlur = _ref.onBlur,
      onBlur = _ref$onBlur === void 0 ? function () {
    return undefined;
  } : _ref$onBlur,
      _ref$onMouseDown = _ref.onMouseDown,
      onMouseDown = _ref$onMouseDown === void 0 ? function () {
    return undefined;
  } : _ref$onMouseDown,
      _ref$autocomplete = _ref.autocomplete,
      autocomplete = _ref$autocomplete === void 0 ? 'off' : _ref$autocomplete,
      rest = _objectWithoutPropertiesLoose(_ref, ["type", "icon", "className", "placeholder", "disabled", "debounceTimeout", "error", "value", "onChange", "readOnly", "theme", "onFocus", "onBlur", "onMouseDown", "autocomplete"]);

  var styles = {
    disabled: disabled,
    error: error,
    withIcon: icon !== undefined
  };

  var _useDebounce = useDebounce(value, onChange, debounceTimeout),
      debouncedValue = _useDebounce[0],
      setDebouncedValue = _useDebounce[1];

  return /*#__PURE__*/React.createElement(theme.Main, Object.assign({
    className: className
  }, rest), /*#__PURE__*/React.createElement(theme.Input, Object.assign({
    type: type,
    value: debouncedValue,
    onChange: function onChange(e) {
      return setDebouncedValue(e.target.value);
    },
    onMouseDown: onMouseDown,
    readOnly: readOnly,
    ref: ref,
    onFocus: onFocus,
    onBlur: onBlur,
    autocomplete: autocomplete,
    "data-test": "input",
    placeholder: placeholder,
    isIcon: !!icon
  }, styles)), /*#__PURE__*/React.createElement(theme.Icon, {
    as: icon
  }));
};

var InputRef = /*#__PURE__*/React.forwardRef
/*:: <Props, StyledComponent> */
(Input);
InputRef.displayName = 'Input';
export default InputRef;